import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppSession } from 'projects/core/src/lib/core/AppSession';
import { GoogleAnalyticsService } from '../services/google-analytics.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuardLogin implements CanActivate {
  constructor(private router: Router, private googleAnalyticsService: GoogleAnalyticsService,) { }

  async canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {

    
    let userAuthenticated = await AppSession.userAuthenticate()
    if (userAuthenticated) {
      let userInApp = await AppSession.getUser()
      if(userInApp != null){
        console.log(userInApp)
        if(userInApp.hasOwnProperty('pagante')){
          this.googleAnalyticsService.setUserProperty(
            'pagante', `${userInApp.pagante ? 'Sim' : 'Nao'}`
          )
        }
        if(userInApp.hasOwnProperty('id')){
          this.googleAnalyticsService.setUserId(userInApp.id)
        }
        this.googleAnalyticsService.logEvent('acesso_login')
      }
      console.log('vai pra home pelo authGuard')
      this.router.navigate(['/navigation/home']);
      return false;
    } else {
      return true;
    }
  }
}